import { DataTable } from "primereact/datatable";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import BarGraph from "../../../../components/bar-chart";
import { Column } from "primereact/column";
import { CSVLink } from "react-csv";
import { numberFormatter } from "../../../../utils/formatter";
import { commodityHeader } from "../../../../utils/constants";
import { Tooltip, Whisper } from "rsuite";
import ProductInfoIcon from "../../../../assets/info-circle-grey.svg";
import { useEffect } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { appInsights } from "../../../../router/router";
import { useVolumeComplianceDistrictsDataDownload } from "../../../../react-query/hooks/HCompliance";

const ActualVsCommited = ({
  vendor,
  vendorData,
  totalVendors,
  setVendor,
  vendorDataTable,
  commodity,
  appInsightsFunc,
  isDownload,
  setIsDownload,
  district,
  month,
}: {
  vendor: string;
  vendorData: [];
  totalVendors: string[];
  setVendor: any;
  vendorDataTable: [];
  commodity: string;
  appInsightsFunc: (module: string, value: string) => void;
  isDownload: boolean;
  setIsDownload: React.Dispatch<React.SetStateAction<boolean>>;
  district: string;
  month: string;
}) => {
  const orderDataTable = [
    "vendor",
    "latest_quote",
    "Total_Commited_Volume",
    "Total_Actual_Volume",
    "overspend",
  ];
  const csvDataTable = [
    // [
    //   "", // Optional header
    //   commodityHeader[commodity] ?? "-",
    //   "Commitment (TLs)",
    //   "Actual (TLs)",
    //   "PPV Opportunity Cost",
    // ],
    ...(vendorDataTable?.map((item: { [x: string]: any }) => {
      return Object.keys(item).map((key, index) => {
        const value = item[orderDataTable[index]];
        return value !== null &&
          value !== undefined &&
          value !== "" &&
          value !== 0 &&
          value !== "0"
          ? value
          : "-";
      });
    }) ?? []),
  ];

  const csvDataGraph = vendorData
    ? [
        ["month", "actual", "commited"],
        ...vendorData?.map((item: { [x: string]: any }) => [
          ...Object.keys(item).map((key, index) => item[key]),
        ]),
      ]
    : [];

  const getExcel = async () => {
    const excelData = await useVolumeComplianceDistrictsDataDownload(
      commodity,
      district,
      [month],
      totalVendors
    );
    const newdata = excelData.data.data.vendorData.graphResForChoosenVendor;
    // const data = [
    //   {
    //     month: "June",
    //     actual: null,
    //     committed: 0,
    //     vendor: "Atkore",
    //   },
    //   {
    //     month: "June",
    //     actual: 22.307925,
    //     committed: 11,
    //     vendor: "Zekelman",
    //   },
    //   {
    //     month: "July",
    //     actual: null,
    //     committed: 2,
    //     vendor: "Atkore",
    //   },
    //   {
    //     month: "July",
    //     actual: 16.478317499999996,
    //     committed: 10,
    //     vendor: "Zekelman",
    //   },
    //   {
    //     month: "August",
    //     actual: null,
    //     committed: 2,
    //     vendor: "Atkore",
    //   },
    //   {
    //     month: "August",
    //     actual: 18.0105275,
    //     committed: 11,
    //     vendor: "Zekelman",
    //   },
    //   {
    //     month: "September",
    //     actual: null,
    //     committed: 2,
    //     vendor: "Atkore",
    //   },
    //   {
    //     month: "September",
    //     actual: 24.7658825,
    //     committed: 10,
    //     vendor: "Zekelman",
    //   },
    //   {
    //     month: "October",
    //     actual: 1.635925,
    //     committed: 1,
    //     vendor: "Atkore",
    //   },
    //   {
    //     month: "October",
    //     actual: 15.6539575,
    //     committed: 8,
    //     vendor: "Zekelman",
    //   },
    //   {
    //     month: "November",
    //     actual: null,
    //     committed: 0,
    //     vendor: "Atkore",
    //   },
    //   {
    //     month: "November",
    //     actual: null,
    //     committed: 9,
    //     vendor: "Zekelman",
    //   },
    // ];
    // const data2 = data.map((ele) => ele.vendor);
    // const data3 = [...new Set(data2)];
    // const data4 = {};
    // data3.forEach((ele) => {
    //   data4[ele] = [...data.filter((element) => ele === element.vendor)];
    // });
    // const newVendorData = newdata.reduce((acc: any, curr: any) => {
    //   if (!acc[curr.vendor]) {
    //     acc[curr.vendor] = [];
    //   }
    //   acc[curr.vendor].push(curr);
    //   return acc;
    // }, {});
    const months = Array.from(
      new Set(newdata.map((d: any) => d.month)) // Get unique months, preserves order
    );

    const vendors = Array.from(new Set(newdata.map((d: any) => d.vendor)));

    // {
    //   string: {
    //     month: string;
    //     actual: number | null;
    //     committed: number | null;
    //     vendor: string;
    //   }[];
    // }

    const newVendorData: any = vendors.reduce((acc: any, vendor: any) => {
      acc[vendor] = months.map((month) => {
        const found = newdata.find(
          (item: {
            month: string;
            actual: number | null;
            committed: number | null;
            vendor: string;
          }) => item.vendor === vendor && item.month === month
        );
        return found ? found : { month, actual: null, committed: null, vendor };
      });
      return acc;
    }, {});
    const vendorList = Object.keys(newVendorData);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Volume Compliance Overview");

    // Add headers and rows based on structure
    worksheet.addRow(["Commodity:", commodity]);
    worksheet.addRow(["District:", district]);
    worksheet.addRow(["Month", month]);
    worksheet.addRow([]); // Empty row

    //First table
    worksheet.mergeCells("A5:E5");
    worksheet.getCell("A5").value = `Volume Commitment Overview for ${month}`;

    //adding headers
    worksheet.addRow([
      "Vendor",
      commodityHeader[commodity] ?? "-",
      "Quote	Commitment (TLs)",
      "Actual (TLs)",
      "PPV Opportunity Cost",
    ]);
    //adding data
    worksheet.addRows(csvDataTable);

    //second table
    const secondTableStart = 3 + 1 + 1 + 1 + vendorDataTable.length + 1 + 1;
    const secondtabkevendorHeaderStart = secondTableStart + 1;

    const secondTableEndCell =
      "A".charCodeAt(0) +
      vendorList.filter((ele) => newVendorData[ele]).length * 2;

    worksheet.mergeCells(
      `A${secondTableStart}:${String.fromCharCode(
        secondTableEndCell
      )}${secondTableStart}`
    );
    worksheet.getCell(
      `A${secondTableStart}`
    ).value = `Last Six Month Committed vs Actual Allocations (TLs)`;

    vendorList.forEach((ele, i) => {
      const vendorListStartCell = "B".charCodeAt(0) + i * 2;
      // const vendorListEndCell = "";
      worksheet.mergeCells(
        `${String.fromCharCode(
          vendorListStartCell
        )}${secondtabkevendorHeaderStart}:${String.fromCharCode(
          vendorListStartCell + 1
        )}${secondtabkevendorHeaderStart}`
      );
      //adding headers
      worksheet.getCell(
        `${String.fromCharCode(
          vendorListStartCell
        )}${secondtabkevendorHeaderStart}`
      ).value = `${
        [...vendorList.filter((ele) => (newVendorData[ele] ? ele : null))][i]
      }`;
    });

    //adding headers
    worksheet.addRow([
      "Month",
      ...vendorList
        .filter((ele) => newVendorData[ele].length)
        .flatMap((ele) => ["Committed", "Actual"]),
    ]);

    //Adding Data
    const n_months = newVendorData[vendorList[0]].length;

    // Build result row-wise
    const result = [];
    for (let i = 0; i < n_months; i++) {
      // Start each row with the month abbreviation (from the first vendor)
      const row = [newVendorData[vendorList[0]][i].month?.slice(0, 3)];
      // For each vendor, push committed then actual value for this row/month
      vendorList.forEach((vendor) => {
        row.push(
          newVendorData[vendor][i].committed
            ? newVendorData[vendor][i].committed
            : "-"
        );
        row.push(
          newVendorData[vendor][i].actual
            ? typeof newVendorData[vendor][i].actual === "number"
              ? +newVendorData[vendor][i].actual.toFixed(2)
              : newVendorData[vendor][i].actual
            : "-"
        );
      });
      result.push(row);
    }

    worksheet.addRows(result);

    // Apply styling to all data rows
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber < 4) {
        // row.getCell(1).font = { bold: true }; // Make the first cell bold
        row.font = { bold: true };
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }

      if (
        (rowNumber > 4 && rowNumber <= 4 + 1 + 1 + vendorDataTable.length) ||
        (rowNumber >= secondTableStart &&
          rowNumber <=
            secondTableStart + 1 + 1 + newVendorData[vendorList[0]].length)
      ) {
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }
      row.font = {
        bold:
          (rowNumber === 5 ||
            rowNumber === 6 ||
            rowNumber === secondTableStart ||
            rowNumber === secondTableStart + 1 ||
            rowNumber === secondTableStart + 2) &&
          true,
      };
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = {
          horizontal:
            rowNumber === 5 ||
            rowNumber === 6 ||
            rowNumber === secondTableStart ||
            rowNumber === secondTableStart + 1 ||
            rowNumber === secondTableStart + 2
              ? "center"
              : "left",
        };
      });
    });
    worksheet.columns.forEach((column: any, i: number) => {
      if (i === 0) {
        column.width = 30;
      } else {
        column.width = 25;
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `Volume Compliance Overview Report.xlsx`);
    appInsightsFunc("Six Months Trend", `Volume Compliance Overview`);
  };

  useEffect(() => {
    if (isDownload) {
      getExcel();
      setIsDownload(false);
    }
  }, [isDownload]);

  useEffect(() => {
    if (
      totalVendors &&
      totalVendors.length > 0 &&
      (!vendor || !totalVendors.includes(vendor))
    ) {
      setVendor(totalVendors[0]);
    }
  }, [totalVendors, vendor]);

  return (
    <>
      <div className="flex justify-between w-full items-center">
        <label className="text-[1.3vw]">
          Last 6 Months Allocations for
          <span className="text-[#86BC25] text-[1.3vw]">
            {totalVendors && totalVendors.length > 0 && (
              <Dropdown
                options={totalVendors}
                value={vendor}
                onChange={(event: DropdownChangeEvent) => {
                  if (event?.target?.value) {
                    setVendor(event?.target?.value);
                  }
                }}
                className="outline-none border-none sixmonth-trend-dropdown"
              />
            )}
          </span>
        </label>
        {/* <div className="text-white bold text-[0.8vw] bg-[#86BC25] p-[0.4vw] rounded-md  cursor-pointer flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1vw"
            height="1vw"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M14.6668 5.33464V9.20797C14.2602 8.97464 13.8135 8.81464 13.3335 8.72797V5.33464H2.66683V12.0013H8.72683C8.6935 12.2213 8.66683 12.4413 8.66683 12.668C8.66683 12.8946 8.6935 13.1146 8.72683 13.3346H2.66683C1.9335 13.3346 1.3335 12.7413 1.3335 12.0013V4.0013C1.3335 3.2613 1.92683 2.66797 2.66683 2.66797H6.66683L8.00016 4.0013H13.3335C14.0668 4.0013 14.6668 4.59464 14.6668 5.33464ZM13.3335 10.668H12.0002V13.3346H10.6668L12.6668 15.3346L14.6668 13.3346H13.3335V10.668Z"
              fill="white"
            />
          </svg>
          <span className="ml-[3px]">
            <CSVLink
              className="no-hover"
              filename={`Last 6 months trend for ${vendor}`}
              style={{ textDecoration: "none" }}
              data={csvDataGraph ?? []}
              onClick={() =>
                appInsightsFunc(
                  "Six Months Trend",
                  `Last 6 months trend for ${vendor}`
                )
              }
            >
              Download
            </CSVLink>
          </span>
        </div> */}
      </div>
      <div className="w-full h-full">
        <div className="w-full mb-[10px] h-[30vh]">
          <BarGraph
            data={vendorData ?? []}
            XAxisLabel="month"
            dataKey1={"committed"}
            dataKey2={"actual"}
          />
        </div>
        <div className="mb-10">
          <div className="flex justify-between mb-[16px] max-h-500:mb-[8px]">
            <label className="text-[1.3vw]">Volume Commitment Overview</label>
            {/* <div className="text-white bold text-[0.8vw] bg-[#86BC25] p-[0.4vw] rounded-md  cursor-pointer flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1vw"
                height="1vw"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M14.6668 5.33464V9.20797C14.2602 8.97464 13.8135 8.81464 13.3335 8.72797V5.33464H2.66683V12.0013H8.72683C8.6935 12.2213 8.66683 12.4413 8.66683 12.668C8.66683 12.8946 8.6935 13.1146 8.72683 13.3346H2.66683C1.9335 13.3346 1.3335 12.7413 1.3335 12.0013V4.0013C1.3335 3.2613 1.92683 2.66797 2.66683 2.66797H6.66683L8.00016 4.0013H13.3335C14.0668 4.0013 14.6668 4.59464 14.6668 5.33464ZM13.3335 10.668H12.0002V13.3346H10.6668L12.6668 15.3346L14.6668 13.3346H13.3335V10.668Z"
                  fill="white"
                />
              </svg>
              <span className="ml-[3px]">
                <CSVLink
                  className="no-hover"
                  filename="Volume Commitment Overview"
                  style={{ textDecoration: "none" }}
                  data={csvDataTable ?? []}
                  onClick={() =>
                    appInsightsFunc(
                      "Six Months Trend",
                      `Volume Commitment Overview`
                    )
                  }
                >
                  Download
                </CSVLink>
              </span>
            </div> */}
          </div>
          <DataTable
            className="custom-2000:h-[85%]"
            value={vendorDataTable ?? []}
            size="small"
            scrollable
          >
            <Column
              style={{
                width: "20vh",
                fontWeight: "bold",
              }}
              field="vendor"
              header=""
            ></Column>
            <Column
              field="latest_quote"
              header={commodityHeader[commodity] ?? ""}
              body={(rowdata) => {
                return (
                  <span>
                    {rowdata?.latest_quote
                      ? numberFormatter(rowdata?.latest_quote, 2, "$")
                      : "-"}
                  </span>
                );
              }}
            ></Column>
            <Column
              field="Total_Commited_Volume"

              header={`Commitment (${
                commodity === "Copper Wire" ? "Lbs" : "TLs"
              })`}
              body={(rowdata) => {
                return (
                  <span>
                    {rowdata?.Total_Commited_Volume
                      ? rowdata?.Total_Commited_Volume
                      : "-"}
                  </span>
                );
              }}
            ></Column>

            <Column
              field="Total_Actual_Volume"

              header={`Actual (${commodity === "Copper Wire" ? "Lbs" : "TLs"})`}
              body={(rowdata) => {
                return (
                  <span>
                    {rowdata?.Total_Actual_Volume
                      ? rowdata?.Total_Actual_Volume
                      : "-"}
                  </span>
                );
              }}
            ></Column>
            <Column
              field="overspend"
              header={
                <Whisper
                  placement="auto"
                  className="inline"
                  speaker={
                    <Tooltip placement="auto">
                      Lost PPV due to allocating extra volume to non-lowest cost
                      suppliers
                    </Tooltip>
                  }
                >
                  PPV Opportunity Cost{" "}
                  <img
                    src={ProductInfoIcon}
                    alt="info"
                    className="w-[1.75vh] cursor-pointer inline"
                  ></img>
                </Whisper>
              }
              body={(rowdata) => {
                return (
                  <span>
                    {rowdata?.overspend
                      ? numberFormatter(rowdata?.overspend, 1, "$")
                      : "-"}
                  </span>
                );
              }}
            ></Column>
          </DataTable>
        </div>
      </div>
    </>
  );
};

export default ActualVsCommited;
